import React, { useState } from 'react';
import '../../../component-styles/TearSheetModal.css';

const TOGGLES = [
  { key: 'showImage', label: 'Cover Image' },
  { key: 'showRoom', label: 'Room' },
  { key: 'showDescription', label: 'Description' },
  { key: 'showVendor', label: 'Vendor' },
  { key: 'showMaterials', label: 'Materials' },
  { key: 'showColorFinish', label: 'Color / Finish' },
  { key: 'showDimensions', label: 'Dimensions' },
  { key: 'showCustomSpecs', label: 'Custom Specs' },
  { key: 'showLink', label: 'Product Link' },
];

export default function TearSheetModal({ defaultTitle, onDownload, onCancel, defaultShowVendor = false }) {
  const [title, setTitle] = useState(defaultTitle || '');
  const [options, setOptions] = useState({
    showImage: true,
    showRoom: true,
    showDescription: true,
    showVendor: defaultShowVendor,
    showMaterials: true,
    showColorFinish: true,
    showDimensions: true,
    showCustomSpecs: true,
    showLink: true,
  });

  const toggle = (key) => setOptions((prev) => ({ ...prev, [key]: !prev[key] }));

  const handleDownload = () => {
    onDownload({ title: title.trim() || defaultTitle || 'Tear Sheet', options });
  };

  return (
    <div className="ts-modal-overlay" onClick={onCancel}>
      <div className="ts-modal" onClick={(e) => e.stopPropagation()}>
        <h3 className="ts-modal__heading">Download Tear Sheets</h3>

        <div className="ts-modal__field">
          <label className="ts-modal__label">Tear Sheet Title</label>
          <input
            className="ts-modal__input"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="e.g. Family Room"
          />
        </div>

        <div className="ts-modal__toggles">
          {TOGGLES.map(({ key, label }) => (
            <label key={key} className="ts-modal__toggle-row">
              <span className="ts-modal__toggle-label">{label}</span>
              <button
                type="button"
                role="switch"
                aria-checked={options[key]}
                className={`ts-modal__switch ${options[key] ? 'ts-modal__switch--on' : ''}`}
                onClick={() => toggle(key)}
              />
            </label>
          ))}
        </div>

        <div className="ts-modal__actions">
          <button type="button" className="ts-modal__cancel" onClick={onCancel}>
            Cancel
          </button>
          <button type="button" className="ts-modal__download" onClick={handleDownload}>
            Download
          </button>
        </div>
      </div>
    </div>
  );
}
